var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortFolio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.22,
    height: 17.463,
    viewBox: "0 0 20.22 17.463",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "briefcase_1_",
    "data-name": "briefcase (1)",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1011",
    "data-name": "Group 1011",
    transform: "translate(0.46 9.65)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1010",
    "data-name": "Group 1010"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M30.478,279.273a.434.434,0,0,0-.46.46v5.974a.434.434,0,0,1-.46.46H13.016a.434.434,0,0,1-.46-.46v-5.974a.46.46,0,1,0-.919,0v5.974a1.354,1.354,0,0,0,1.379,1.379H29.559a1.354,1.354,0,0,0,1.379-1.379v-5.974A.434.434,0,0,0,30.478,279.273Z",
    transform: "translate(-11.637 -279.273)",
    fill: "#67E1AE"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1013",
    "data-name": "Group 1013",
    transform: "translate(0 3.217)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1012",
    "data-name": "Group 1012"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M18.841,116.364H1.379A1.354,1.354,0,0,0,0,117.743v2.941a1.379,1.379,0,0,0,1.057,1.333l7.215,1.608V125.1a.434.434,0,0,0,.46.46h2.757a.434.434,0,0,0,.46-.46v-1.471l7.215-1.608a1.379,1.379,0,0,0,1.057-1.333v-2.941A1.354,1.354,0,0,0,18.841,116.364Zm-7.812,8.272H9.191V122.8h1.838Zm8.272-3.952a.447.447,0,0,1-.368.46l-6.985,1.562v-.368a.434.434,0,0,0-.46-.46H8.731a.434.434,0,0,0-.46.46v.368l-6.985-1.562a.448.448,0,0,1-.368-.46v-2.941a.434.434,0,0,1,.46-.46H18.841a.434.434,0,0,1,.46.46Z",
    transform: "translate(0 -116.364)",
    fill: "#67E1AE"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1015",
    "data-name": "Group 1015",
    transform: "translate(6.434)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1014",
    "data-name": "Group 1014"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M168.883,34.909h-4.6a1.354,1.354,0,0,0-1.379,1.379v.46a.46.46,0,1,0,.919,0v-.46a.434.434,0,0,1,.46-.46h4.6a.434.434,0,0,1,.46.46v.46a.46.46,0,0,0,.919,0v-.46A1.354,1.354,0,0,0,168.883,34.909Z",
    transform: "translate(-162.909 -34.909)",
    fill: "#67E1AE"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortFolio);
export default __webpack_public_path__ + "static/media/portFolio.35256069e2880fe48d2d980c6b925115.svg";
export { ForwardRef as ReactComponent };